import React, { useEffect, useState } from 'react'
import './Addvideo.css'
import Select from "react-select"
import { ToastContainer, toast } from 'react-toastify'
import { AddVideoApi } from '../../Services/allApi'
import { Navigate, useNavigate } from 'react-router-dom'

function EditVideo() {

    //inputType is initialized to 'text'
    const [inputType, setInputType] = useState('text');

    const navigate = useNavigate()
    const sessionoptions = [
        { value: 1, label: "Session 1" },
        { value: 2, label: "Session 2" },
        { value: 3, label: "Session 3" },
        { value: 4, label: "Session 4" }
    ]

    const klaoptions = [
        { value: 1, label: "KLA 1" },
        { value: 2, label: "KLA 2" },
        { value: 3, label: "KLA 3" },
        { value: 3, label: "KLA 4" }
    ]
    const eventoptions = [
        { value: 1, label: "Event 1" },
        { value: 2, label: "Event 2" },
        { value: 3, label: "Event 3" },
        { value: 4, label: "Event 4" }
    ]

    const memberoptions = [
        { value: 1, label: "Member 1" },
        { value: 2, label: "Member 2" },
        { value: 3, label: "Member 3" },
        { value: 4, label: "Member 4" }
    ]

    // Define the initial state for tags
    const [tags, setTags] = useState({});
    const [tagCount, setTagCount] = useState(1);

    // Tag constructor function
    function Tag(key, value) {
        this.key = key;
        this.value = value;
    }

    const [keyFromInput, setkeyFromInput] = useState('')
    const [ValueFromInput, setValueFromInput] = useState('')
    // var keyFromInput=''
    // var ValueFromInput=''

    //on changing the input field set keyfromInput to event e
    const handleKeyInput = (e) => {
        setkeyFromInput(e)
    }
    //on changing the input field set valuefromInput to event e
    const handleValueInput = (e) => {
        setValueFromInput(e)
    }


    // Function to handle adding a new tag
    const handleTagAdd = () => {
        if (keyFromInput && ValueFromInput) {
            // use Tag constructor to add a new tag with values from keyFormInput an valueFormInput states
            const newTag = new Tag(`${keyFromInput}`, `${ValueFromInput}`);
            //add the newly created tag with other tags alongwith a tag count
            setTags(prevTags => ({ ...prevTags, [`tag${tagCount}`]: newTag }));
            setTagCount(prevCount => prevCount + 1);
            console.log(tags);
            // keyFromInput=''
            // ValueFromInput=''
            setkeyFromInput('')
            setValueFromInput('')
        }
        else {
            toast.warning("Please enter tag as key value pair")
        }
    };
    //deletes a tag when a tag is removed by the user
    const handleRemoveTag = (key, value) => {
        const newTags = { ...tags };
        delete newTags[key];
        setTags(newTags);
    }

    const [VideoDetails, setVideoDetails] = useState({
        video_url: 'jsdclknclksdnldne',
        video_sequence_no: '4',
        video_title: 'Budget Speech',
        video_subject: 'here we can see video subject ',
        video_upload_date: '03/23/2022',
        kla: '2',
        video_session: '4',
        video_event: 'Budget Speech',
        video_member: [1],
        video_tags: {}
    })

    //when the details are submitted by the user handleSave function is invoked
    const handleSave = async () => {
        const updatedTags = {};
        Object.entries(tags).forEach(([tagName, tag]) => {
            updatedTags[tag.key] = tag.value;
        });
        //add the updated tags to videoDetails
        setVideoDetails(prevDetails => ({
            ...prevDetails,
            video_tags: updatedTags
        }));
        //get the access_token and add it to header
        var token = sessionStorage.getItem('access_token')
        const reqHeader = {
            "Content-Type": "application/json", "Authorization": `${token}`
        }
        // if (VideoDetails.video_url && VideoDetails.video_sequence_no && VideoDetails.video_title && VideoDetails.video_subject && VideoDetails.video_upload_date && VideoDetails.kla && VideoDetails.video_session && VideoDetails.video_event && VideoDetails.video_member) {
        //     const res = await AddVideoApi(VideoDetails, reqHeader)
        //     console.log(res);
        //     if (res.status == 200) {
        //         toast.success("Video added successfully")
        //         setVideoDetails({
        //             video_url: '',
        //             video_sequence_no: '',
        //             video_title: '',
        //             video_subject: '',
        //             video_upload_date: '',
        //             kla: '',
        //             video_session: '',
        //             video_event: '',
        //             video_member: [],
        //             video_tags: {}
        //         })

        //         setSelectedOptionMember(null)
        //         setSelectedOptionKLA(null)
        //         setSelectedOptionSession(null)
        //         setSelectedOptionEvent(null)
        //     }
        //     console.log(VideoDetails);
        // }
        // else {
        //     toast.warning("Please fill the form completely")
        // }
    };


    const [selectedOptionKLA, setSelectedOptionKLA] = useState(null)
        // when a value is selected from the option provided in KLA, handelchangekla is called///
    const handlechangekla = (selectedOptionKLA) => {
        //updating both selectedOptionKLA and the VideoDetails state variable with the new kla value.
        setSelectedOptionKLA(selectedOptionKLA)
        setVideoDetails({ ...VideoDetails, kla: selectedOptionKLA.value })
    }
    
    const [selectedOptionSession, setSelectedOptionSession] = useState(null)
    // when a value is selected from the option provided in session, handelchangesession is called
    const handlechangesession = (selectedOptionSession) => {
        //updating both selectedOptionSession and the VideoDetails state variable with the new session value.
        setSelectedOptionSession(selectedOptionSession)
        setVideoDetails({ ...VideoDetails, video_session: selectedOptionSession.value })
    }

    const [selectedOptionEvent, setSelectedOptionEvent] = useState(null)
    // when a value is selected from the option provided in Event, handelchangeevent is called
    const handlechangeevent = (selectedOptionEvent) => {
        //updating both selectedOptionEvent and the VideoDetails state variable with the new event value.
        setSelectedOptionEvent(selectedOptionEvent)
        setVideoDetails({ ...VideoDetails, video_event: selectedOptionEvent.value })
    }

    const [selectedOptionMember, setSelectedOptionMember] = useState(null)
    // when a value is selected from the option provided in Member, handelchangemember is called
    const handlechangemember = (selectedOptionMember) => {
        //updating both selectedOptionMmeber and the VideoDetails state variable with the new member value.
        setSelectedOptionMember(selectedOptionMember)
        setVideoDetails(prevDetails => ({
            ...prevDetails,
            video_member: [selectedOptionMember.value]
        }));
    }
    //on clicking the cancel button the handleCancel button resets all the fields  
    const handleCancel = () => {
        setVideoDetails({
            video_url: '',
            video_sequence_no: '',
            video_title: '',
            video_subject: '',
            video_upload_date: '',
            kla: '',
            video_session: '',
            video_event: '',
            video_member: [],
            video_tags: {}
        })
        setSelectedOptionMember(null)
        setSelectedOptionKLA(null)
        setSelectedOptionSession(null)
        setSelectedOptionEvent(null)
        navigate('/user/admin')
    }
    // when the input field is focused inputType value is set to 'date'
    const handleFocus = () => {
        setInputType('date');
    };
    //when the input field loses focus handleBlur is invoked
    // Sets the inputType to 'text' when it losses focus
    const handleBlur = (e) => {
        if (!e.target.value) {
            setInputType('text');
        }
    };

    return (

        <div className='w-full h-full flex justify-center' style={{ fontFamily: 'ropa sans' }}>
            <div className='w-9/12  flex flex-col '>
                <div className='flex justify-center '><h2 className='mt-12 md:text-xl text-md'>Add New Video</h2></div>

                {/* row 1 */}
                <div className='flex flex-row justify-between flex-wrap mt-16'>

                    {/*Edit video url */}
                    <div className='mt-6 flex flex-col md:w-5/12 w-full'>
                        <label htmlFor="videourl">Video URL</label>
                        <input value={VideoDetails.video_url} onChange={(e) => setVideoDetails({ ...VideoDetails, video_url: e.target.value })} type="text" name="" id="videourl" className='w-fll h-12 rounded-lg' style={{ border: '1px solid #384D6C' }} />
                    </div>

                    {/*Edit Sequence Number */}
                    <div className='mt-6 flex flex-col md:w-5/12 w-full'>
                        <label htmlFor="seqnumber">Sequence Number</label>
                        <input value={VideoDetails.video_sequence_no} onChange={(e) => setVideoDetails({ ...VideoDetails, video_sequence_no: e.target.value })} type="text" name="" id="seqnumber" className='w-fll h-12 rounded-lg' style={{ border: '1px solid #384D6C' }} />
                    </div>



                </div>


                {/* row 2 */}
                <div className='flex flex-row justify-between flex-wrap'>

                    {/*Edit Title */}
                    <div className='mt-6 flex flex-col md:w-5/12 w-full'>
                        <label htmlFor="title">Video Title</label>
                        <input value={VideoDetails.video_title} onChange={(e) => setVideoDetails({ ...VideoDetails, video_title: e.target.value })} type="text" name="" id="title" className='w-fll h-12 rounded-lg' style={{ border: '1px solid #384D6C' }} />
                    </div>

                    {/*Edit Subject */}
                    <div className='mt-6 flex flex-col md:w-5/12 w-full'>
                        <label htmlFor="subject">Subject</label>
                        <input value={VideoDetails.video_subject} onChange={(e) => setVideoDetails({ ...VideoDetails, video_subject: e.target.value })} type="text" name="" id="subject" className='w-fll h-12 rounded-lg' style={{ border: '1px solid #384D6C' }} />
                    </div>



                </div>

                {/* row 3 */}
                <div className='flex flex-row justify-between flex-wrap'>

                    {/*Edit Date */}
                    <div className='mt-6 flex flex-col md:w-5/12 w-full'>
                        <label htmlFor="date">Date</label>
                        <input type={inputType}
                            onFocus={handleFocus}
                            onBlur={handleBlur}
                            placeholder="dd/mm/yyyy" value={VideoDetails.video_upload_date} onChange={(e) => setVideoDetails({ ...VideoDetails, video_upload_date: e.target.value })} name="" id="dateInput" className='dateinput w-fll h-12 rounded-lg ' style={{ border: '1px solid #384D6C' }} />
                    </div>

                    {/*Edit Session */}
                    <div className='mt-6 flex flex-col md:w-5/12 w-full'>
                        <label htmlFor="kla">KLA</label>
                        {/* <input type="text" name="" id="session" className='w-fll h-12 rounded-lg' style={{border:'1px solid #384D6C'}}/> */}
                        {/* <div className='w-fll h-12 rounded-lg' style={{border:'1px solid #384D6C'}}>  */}
                        
                        {/* select component for selecting event from options provided in klaoptions */}
                        <Select
                            
                            placeholder={`KLA ${VideoDetails.kla}`}
                            id='kla'
                            styles={{
                                //control property is a function that takes in two arguments(baseStyles,state)
                                //baseStyles contains default style for control element
                                // state contains information about current state of control element
                                control: (baseStyles, state) => ({
                                    ...baseStyles,
                                    borderColor: state.isFocused ? '#384D6C' : '#384D6C',
                                    height: '3rem',
                                    borderRadius: '0.5rem',

                                }),
                            }}
                            className=''
                            options={klaoptions}
                            value={selectedOptionKLA}
                            onChange={handlechangekla} />
                    </div>
                    {/* </div> */}
                </div>

                {/* row 4 */}
                <div className='flex flex-row justify-between flex-wrap'>

                    {/* Session */}
                    <div className='mt-6 flex flex-col md:w-5/12 w-full'>
                        <label htmlFor="session">Session</label>
                        {/* <input type="text" name="" id="videourl" className='w-fll h-12 rounded-lg' style={{border:'1px solid #384D6C'}}/> */}
                        
                        {/* select component for selecting event from options provided in sessionoptions */}
                        <Select
                         placeholder={`Session ${VideoDetails.video_session}`}
                            id='session'
                            styles={{
                                //control property is a function that takes in two arguments(baseStyles,state)
                                //baseStyles contains default style for control element
                                // state contains information about current state of control element
                                control: (baseStyles, state) => ({
                                    ...baseStyles,
                                    borderColor: state.isFocused ? '#384D6C' : '#384D6C',
                                    height: '3rem',
                                    borderRadius: '0.5rem',

                                }),
                            }}
                            className=''
                            options={sessionoptions}
                            value={selectedOptionSession}
                            onChange={handlechangesession} />
                    </div>

                    {/*Edit Event */}
                    <div className='mt-6 flex flex-col md:w-5/12 w-full'>
                        <label htmlFor="event">Event</label>

                         {/* select component for selecting event from options provided in eventoptions */}
                        <Select
                         placeholder={`Event ${VideoDetails.video_event}`}
                            id='event'
                            styles={{
                                //control property is a function that takes in two arguments(baseStyles,state)
                                //baseStyles contains default style for control element
                                // state contains information about current state of control element
                                control: (baseStyles, state) => ({
                                    ...baseStyles,
                                    borderColor: state.isFocused ? '#384D6C' : '#384D6C',
                                    height: '3rem',
                                    borderRadius: '0.5rem',

                                }),
                            }}
                            className=''
                            options={eventoptions}
                            value={selectedOptionEvent}
                            onChange={handlechangeevent} />
                    </div>
                </div>


                {/* row 5 */}
                <div className='flex flex-row justify-between flex-wrap'>

                    {/*Edit Tag */}
                    <div className='mt-6 flex flex-col md:w-5/12 w-full'>
                        <label htmlFor="videourl">Add Tag</label>
                        <div className='flex flex-row justify-between'>
                            <input type="text" placeholder='key' style={{ border: '1px solid #384D6C' }} className='placeholder rounded-lg h-12 w-4/12' value={keyFromInput} onChange={e => handleKeyInput(e.target.value)} />
                            <input type="text" placeholder='Value' style={{ border: '1px solid #384D6C' }} className='placeholder rounded-lg h-12 md:w-6/12 w-5/12' value={ValueFromInput} onChange={e => handleValueInput(e.target.value)} />
                            <button className='rounded-lg bg-primary text-white md:w-1/12 w-2/12' onClick={handleTagAdd}>Add</button>
                        </div>
                    </div>

                    {/*Edit Member */}
                    <div className='mt-6 flex flex-col md:w-5/12 w-full'>
                        <label htmlFor="member">Member</label>
                        {/* <input type="text" name="" id="videourl" className='w-fll h-12 rounded-lg' style={{border:'1px solid #384D6C'}}/> */}
                       
                       {/* select component for selecting event from options provided in memberoptions */}
                        <Select
                         placeholder={memberoptions[VideoDetails.video_member].label}
                            id='member'
                            styles={{
                                //control property is a function that takes in two arguments(baseStyles,state)
                                //baseStyles contains default style for control element
                                // state contains information about current state of control element
                                control: (baseStyles, state) => ({
                                    ...baseStyles,
                                    borderColor: state.isFocused ? '#384D6C' : '#384D6C',
                                    height: '3rem',
                                    borderRadius: '0.5rem',

                                }),
                            }}
                            className=''
                            options={memberoptions}
                            value={selectedOptionMember}
                            onChange={handlechangemember} />
                    </div>


                </div>

                {/*Row 6 Tags View , Action Buttons*/}
                <div className='flex flex-row justify-between flex-wrap'>

                    {/* Show Tags */}
                    <div className=' flex flex-col md:w-5/12 w-full mb-10 '>
                        {Object.entries(tags).map(([tagName, tag], index) => (
                            <div className='flex flex-row justify-between mt-5 ' key={index}>
                                <div className='w-4/12 h-12 rounded-lg bg-primary text-white flex justify-center items-center' >{tag.key}</div>
                                <div className=' md:w-6/12 w-5/12 h-12 rounded-lg bg-primary text-white flex justify-center items-center' >{tag.value}</div>
                                <div className='md:w-1/12 w-2/12 h-12 '><button className='rounded-lg w-full h-full bg-primary text-white' style={{ border: '1px solid white' }} onClick={() => handleRemoveTag(tagName, tag.value)}><i class="fa-solid fa-xmark"></i></button></div>
                            </div>
                        ))}
                    </div>

                    {/* action Buttons */}
                    <div className='flex flex-row flex-wrap md:justify-start justify-center'>
                        <div className='flex justify-evenly flex-row mt-10'>
                            <button className='h-10 bg-primary w-28 text-white rounded-lg' onClick={handleSave}>Save</button>
                            <button className='ms-10 h-10 bg-white w-28 text-primary rounded-lg border-2 hover:bg-blue-200' onClick={handleCancel}>Cancel</button>
                        </div>
                    </div>

                    {/* </div> */}
                </div>



            </div>

            <ToastContainer
                style={{ width: '400px', /* other styles */ }}
                position="top-center"
                autoClose={4000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="light"
            />
        </div>


    )
}

export default EditVideo